// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import campaignActivityEntity from './entities/campaign-activity.json';
import campaignActivityMenu from '../pages/campaign-activity/menu.json';
import campaignActivityFullForm from '../pages/campaign-activity/forms/full.json';
import campaignActivityContextForm from '../pages/campaign-activity/forms/context.json';
import campaignActivityMiniForm from '../pages/campaign-activity/forms/mini.json';
import campaignActivityLookupForm from '../pages/campaign-activity/forms/lookup.json';
import campaignActivityTableView from '../pages/campaign-activity/views/table.json';
import campaignActivityCardsView from '../pages/campaign-activity/views/cards.json';
import campaignActivityDashboardView from '../pages/campaign-activity/views/dashboard.json';

/** Тип запису «Активність кампанії» зі сторінками пакета: меню, форми та подання з pages/campaign-activity/. */
export const campaignActivityDefinition: IRecordTypeDefinition = {
  ...campaignActivityEntity,
  views: assembleViewSet({
      table: campaignActivityTableView,
      cards: campaignActivityCardsView,
      dashboard: campaignActivityDashboardView,
  }),
  form: campaignActivityFullForm,
  forms: { full: campaignActivityFullForm, context: campaignActivityContextForm, mini: campaignActivityMiniForm, lookup: campaignActivityLookupForm },
  menu: campaignActivityMenu,
} as IRecordTypeDefinition;
